import { render } from "./BinanceNewUi.vue?vue&type=template&id=8c8c67fc&scoped=true"
import script from "./BinanceNewUi.vue?vue&type=script&lang=js"
export * from "./BinanceNewUi.vue?vue&type=script&lang=js"

import "./BinanceNewUi.vue?vue&type=style&index=0&id=8c8c67fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c8c67fc"]])

export default __exports__